module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p4.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/dish"
    }
  }, [_vm._v("A DISH FOR EVERY DAY")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01"
    }
  }, [_vm._v("JANUARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap02"
    }
  }, [_vm._v("FEBRUARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARCH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APRIL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUNE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JULY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUGUST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEPTEMBER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCTOBER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOVEMBER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DECEMBER")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0